import { render, staticRenderFns } from "./checkTask.vue?vue&type=template&id=ec6a5b34&scoped=true"
import script from "./checkTask.vue?vue&type=script&lang=js"
export * from "./checkTask.vue?vue&type=script&lang=js"
import style0 from "./checkTask.vue?vue&type=style&index=0&id=ec6a5b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6a5b34",
  null
  
)

export default component.exports